var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0039 2.25H1V16.25H20.0039V2.25ZM10.502 9.25L4.51367 4.24609H16.4355L10.502 9.25ZM2.99609 14.2539V5.24414L10.5156 11.2461L17.9941 5.24414V14.2539H2.99609Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.72,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 16.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.271afbf1b00c62bd0382412cc323b493.svg";
export { ForwardRef as ReactComponent };